import { useQuery } from "@tanstack/react-query";
import { EmployeeService, IGetHRProfileParams } from "../../../../../services/vos/business-tickets/employee.service";

const useHrProfile = (params?: IGetHRProfileParams) => {
  const query = useQuery({
    queryKey: ["hr-profile", params?.email],
    queryFn: () => EmployeeService.getHRProfile(params),
    keepPreviousData: true,
    enabled: !!params?.email,
  });

  return query;
};

export default useHrProfile;
